import * as paymentTypes from '../types/paymentTypes';

const initialState = {
  payment: null,
  paymentUrl: null,
  loading: false,
  error: null,
  message: null,
};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case paymentTypes.INITIALIZE_PAYMENT_REQUEST:
    case paymentTypes.VERIFY_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        message: null,
      };

    case paymentTypes.INITIALIZE_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentUrl: action.payload.paymentUrl || action.payload.url || null,
        payment: action.payload || null,
        error: null,
      };

    case paymentTypes.VERIFY_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        payment: action.payload || null,
        paymentUrl: null,
        message: 'Payment verified successfully',
        error: null,
      };

    case paymentTypes.INITIALIZE_PAYMENT_FAILURE:
    case paymentTypes.VERIFY_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case paymentTypes.CLEAR_PAYMENT_ERROR:
      return { ...state, error: null };

    case paymentTypes.CLEAR_PAYMENT_MESSAGE:
      return { ...state, message: null };

    default:
      return state;
  }
};

export default paymentReducer;
